module.exports = __webpack_public_path__ + "assets/img/icon-kf-b63de0c0.png";